// Aquí están los thunks relacionados con la autenticación
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "@/app/store";
import api from "@/services/api";
import { apiAuth } from "@/services/api";
import { loginSuccess, loginFailure, loginReset, logout } from "./authSlice";

/**
 * 🔐 LOGIN — Envía credenciales y guarda el accessToken + user
 */

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ username, password }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(loginReset());
      const { data } = await api.post("/auth/log-in", { username, password });
      // console.log("Datos de login recibidos:", data);
      // debugger;
      dispatch(
        loginSuccess({
          user: data.user,
          accessToken: data.AuthenticationResult.AccessToken,
          idToken: data.AuthenticationResult.IdToken,
        })
      );

      return data;
    } catch (err) {
      // debugger;
      dispatch(
        loginFailure(
          err.response?.data || err.response?.data?.message || "Error de login"
        )
      );
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error de login"
      );
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { dispatch, rejectWithValue }) => {
    const configHeaders = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${store.getState().auth.accessToken}`,
      },
    };
    try {
      const { data } = await apiAuth.post("/auth/log-out", {}, configHeaders);

      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al cerrar sesión"
      );
    } finally {
      // Redirigir al usuario a la página del home al cerrar sesión
      dispatch(logout());
      setTimeout(() => {
        window.location.href = "/";
      }, 500);
    }
  }
);

/**
 * 🔄 REFRESH TOKEN — obtiene nuevo accessToken cuando expira
 */
export const refreshAccessToken = createAsyncThunk(
  "auth/refreshAccessToken",
  async (_, { dispatch, rejectWithValue }) => {
    // debugger;
    const configHeaders = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${store.getState().auth.accessToken} ${store.getState().auth.idToken}`,
      },
    };
    try {
      const { user } = store.getState().auth;
      console.log("Usuario actual al refrescar token:", user);
      // debugger;
      if (!user || !user.correo) {
        throw new Error("No hay usuario autenticado para hacer refresh");
      }
      // debugger;
      const { data } = await apiAuth.post(
        "/auth/refresh",
        { username: user.correo },
        configHeaders
      );
      // debugger;
      dispatch(
        loginSuccess({
          user: data.user,
          accessToken: data.AuthenticationResult.AccessToken,
          idToken: data.AuthenticationResult.IdToken,
        })
      );
      // debugger;
      return data;
    } catch (err) {
      dispatch(logout());
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al refrescar token"
      );
    }
  }
);
